import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Router from "./router/Router";
import ReactGA from "react-ga";
import { useEffect } from "react";
import { store } from "../src/store";

// * For Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";

const HOST = window.location.host;

let TRACKING_ID = "";

if (HOST.includes("yoindi")) {
  TRACKING_ID = "G-NC1QK42XSJ";
}

console.log("Tracking ID : ", TRACKING_ID);
ReactGA.initialize(TRACKING_ID);

const App = () => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <div className="App">
      <Provider store={store}>
      <Router />
      {/* <ToastContainer /> */}
      </Provider>
    </div>
  );
};

export default App;
